// @ts-ignore
import { tw } from "@careinfo/tailwind";
import usePostHook from "../../hooks/usePostHook";
import APIS from "../../constant/Endpoint";
import { useEffect, useState } from "react";

const ProfileTab = ({ data }) => {
  const [userName, setUserName] = useState("");

  const { mutateAsync: postProfile, isPostLoading } = usePostHook({
    queryKey: ["profile"],
  });
  const handleUpdateProfile = async () => {
    const url = `${APIS.EMAIL}setup/`;
    let formData = {
      full_name: userName,
      username: data?.username,
    };
    try {
      const res = await postProfile({ url, formData });
      if (res?.status === 200) {
        console.log("successfullllll");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data && data.username) {
      setUserName(data?.full_name);
    }
  }, [data]);
  return (
    <div className={tw`h-full p-8 bg-gradient-to-br from-blue-50 to-white`}>
      <div className={tw`flex gap-4 mb-6`}>
        {/* Username Field */}
        <div className={tw`flex-1`}>
          <label className={tw`block text-sm font-medium text-gray-700 mb-2`}>
            Full Name
          </label>
          <input
            type="text"
            value={userName || ""}
            placeholder="Enter full name"
            onChange={(e) => setUserName(e.target.value)}
            className={tw`w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none `}
          />
        </div>

        {/* Account ID Field */}
        <div className={tw`flex-1`}>
          <label className={tw`block text-sm font-medium text-gray-700 mb-2`}>
            Account ID
          </label>
          <input
            type="text"
            disabled={true}
            value={data?.username || ""}
            placeholder="Account ID"
            className={tw`w-full px-4 py-2.5 border border-gray-300 rounded-lg bg-gray-50 cursor-not-allowed text-gray-600 focus:outline-none`}
          />
        </div>
      </div>

      {/* Update Button */}
      <div>
        <button
          type="button"
          disabled={isPostLoading}
          onClick={handleUpdateProfile}
          className={tw`px-6 py-2.5 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600  transition-colors focus:outline-none`}
        >
          {isPostLoading ? "Updating..." : "Update Profile"}
        </button>
      </div>
    </div>
  );
};

export default ProfileTab;
